const filters = {

    'filters.waiting.sync': 'Wachten op synchronisatie',
    'filters.adjusted.synced': 'Aangepast en gescynchroniseerd',

    'filters.adjusted.show': 'Tonen in webshop is aangepast',
    'filters.adjusted.name': 'Naam is aangepast',
    'filters.adjusted.price': 'Prijs is aangepast',
    'filters.adjusted.unique_code': 'Productnummer is aangepast',
    'filters.adjusted.category': 'Categorie is aangepast',
    'filters.adjusted.additional_categories': 'Additionele categorieën ingesteld',
    'filters.adjusted.seo': 'SEO is aangepast',

    'filters.remove': 'Verwijder filter opties',

    'filters.product.types.critical': 'Kritiek',
    'filters.product.types.info': 'Info',

    'filters.product.jobs.collect': 'Verzamelen',
    'filters.product.jobs.connect': 'Connectie',
    'filters.product.jobs.sync': 'Synchroniseren',

};

export default filters;
